import React from 'react';
import { CButton, CModal, CModalBody, CModalHeader } from '@coreui/react';
interface IProps {
  show: boolean;
  onOK: Function;
  text: string;
  onClose: Function;
}

const Modal: React.FC<IProps> = ({ show, onOK, text, onClose }) => {
  return (
    <CModal
      show={show}
      backdrop={true}
      closeOnBackdrop={false}
      className="dialog-common"
      onClose={onClose}
    >
      <CModalHeader closeButton>
        <h6 className=" font-weight-bold text-white-dark-theme" style={{ marginTop: '11px' }}>
          {text}
        </h6>
      </CModalHeader>

      <CModalBody>
        <div>
          <div className="w-100  d-flex justify-content-center">
            <CButton color="info" className="ml-auto mr-0 bg-info px-4" onClick={() => onOK()}>
              OK
            </CButton>
          </div>
        </div>
      </CModalBody>
    </CModal>
  );
};
export default Modal;
